export default  {
  bindings: {
    options: '<',
  },
  controller: 'optionsListController',
  template: require('../views/options.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/options.list.component.js